import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Footer from "../Footer";
import BottomBarIcons from "../BottomBarIcons";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import excelExportIcon from "../../assets/img/exportExcelRed.png";
import activeDownloadIcon from "../../assets/img/activeDownloadIcon.png";
import Iframe from "react-iframe";
import {
  GET_ALL_INSPECTION_MASTER,
  DELETE_PROPERTY_INSPECTION,
  DOOR_INSPECTION_API,
  DOWNLOAD_EXCEL_FILE,
  EXPORT_EXCEL_INSPECTIONS,
} from "../../api/apiPath";
// import { hostName } from "../../config/config";

import Header from "../Header";
import Sidebar from "../Sidebar";
// import NewDynamicTable from "../common/NewDynamicTable";

import DynamicTable from "../common/DynamicTable";
import Toaster from "../common/Toaster";
import ConfirmationPopup from "../common/ConfirmationPopup";
import InspectionTile from "./InspectionTile";
import { Statuses } from "../common/constant";
import LoadingComponent from "../common/LoadingComponent";

// import { Box } from "@mui/material";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SidebarIcons from "../SidebarIcons";
import FilterSection from "../common/FilterSection";
import StatusPill from "../common/StatusPill";

import activeSchduleIcon from "../../assets/img/activeScheduleIcon.png";
import activeEditIcon from "../../assets/img/activeEditIcon.png";
import activeDeleteIcon from "../../assets/img/aciveDeleteIcon.png";
import activeHistoryIcon from "../../assets/img/activeHistoryIcon.png";
import disabledScheduleIcon from "../../assets/img/disabledScheduleIcon.png";
import disabledEditIcon from "../../assets/img/disabledEditIcon.png";
import disabledDeleteIcon from "../../assets/img/disabledDeleteIcon.png";

// For duplicate inspection this two import required

import disabledDuplicateIcon from "../../assets/img/disabledDuplicateIcon.png";
import activeDuplicateIcon from "../../assets/img/ActiveDuplicateIcon.png";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";

// import HistoryIcon from '@mui/icons-material/History';
// import { InputAdornment, TextField } from "@mui/material";
// import { sampleInspectorRows } from "../common/constant";

const Inspections = () => {
  const { clientNameParam } = useParams();
  const { userObj } = useSelector((state) => state.user);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [exportLoadingRowId, setExportLoadingRowId] = useState(null);
  const navigate = useNavigate();
  const [toolbar, setToolBar] = useState({
    searchText: "",
    propertyName: "Property Name",
    inspector: "Inspector",
    status: "Status",
  });
  const [loading, setLoading] = useState(true);

  const [dateRange, setDateRange] = useState([null, null]);
  const [inspectorOptions, setInspectorOptions] = useState([]);

  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.propertyName !== "Property Name" ||
    toolbar.inspector !== "Inspector" ||
    dateRange[0] !== null ||
    dateRange[1] !== null ||
    toolbar.status !== "Status";
  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  const closePopup = () => {
    setShowConfirmationPopup(false);
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
      //setAllPropertyList(sampleInspectorRows);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientId,
      );
      if (response.status === 200) {
        const tempArr = [];
        let tempInsp = [];
        response?.data.map((inspection) => {
          const inspectorsArr = inspection.assignedInspectors.map(
            (item) => item.inspectorName,
          );
          const newObj = {
            id: inspection.inspectionMasterId,
            propertyMasterId: inspection.properties[0]?.propertyMasterId,
            propertyName: inspection.properties[0]?.propertyName,
            buildingName: inspection?.buildingName,
            buildingId: inspection?.buildingId,
            inspector: inspectorsArr.join(", "),
            // date: new Date(inspection.approvalDueDate).toLocaleDateString(
            //   "en-GB"
            // ),
            date: inspection?.approvalDueDate
              ? new Date(inspection.approvalDueDate).toLocaleDateString("en-GB")
              : "N/A",

            CreatedDate: new Date(inspection.createdDate).toLocaleDateString(
              "en-GB",
            ),
            status: inspection.status,
            isOverDue: inspection.isOverDue,
            inspectionMasterId: inspection.inspectionMasterId,
            inspectionRefNumber: inspection.inspectionReferenceNumber,
            inspectionDate: inspection.scheduledInspectionDate
              ? new Date(inspection.scheduledInspectionDate).toLocaleDateString(
                  "en-GB",
                )
              : "N/A",
          };
          tempInsp = [...tempInsp, ...inspectorsArr];
          tempArr.push(newObj);
        });
        console.log("response.data", response.data, tempArr);
        setAllPropertyList(tempArr);
        // setInspectorOptions(tempInsp);
        const uniqueSortedInspectors = Array.from(
          new Set(tempInsp), // remove duplicates
        ).sort((a, b) => a.localeCompare(b)); // alphabetical sort

        setInspectorOptions(uniqueSortedInspectors);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  const openEditScreen = (inspectionMasterId) => {
    const pathTemplate =
      "/client/:clientNameParam/inspection/:inspectionMasterId";
    const params = {
      clientNameParam: clientNameParam,
      inspectionMasterId: inspectionMasterId,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };
  const openScheduleScreen = (inspectionMasterId) => {
    const pathTemplate =
      "/client/:clientNameParam/scheduleInspection/:inspectionMasterId";
    const params = {
      clientNameParam: clientNameParam,
      inspectionMasterId: inspectionMasterId,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };
  // const openScheduleInspectionRefNumberScreen = (inspectionRefNumber) => {
  //    const pathTemplate = "/client/:clientNameParam/Calendar/:inspectionRefNumber";
  //       const params = {
  //         clientNameParam: clientNameParam,
  //         inspectionRefNumber: inspectionRefNumber,
  //       };

  //       const fullPath = generatePath(pathTemplate, params);
  //       navigate(fullPath);
  // };
  const openAuditScreen = (inspectionMasterId, propertyMasterId) => {
    const pathTemplate =
      "/client/:clientNameParam/BookingHistory/:inspectionMasterId/:propertyMasterId";
    const params = {
      clientNameParam: clientNameParam,
      inspectionMasterId: inspectionMasterId,
      propertyMasterId: propertyMasterId,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  // For Duplicate Inspection this function is used

  const checkAllowDuplicate = (selectedRow) => {
    const isCompleted =
      selectedRow.status === Statuses.COMPLETED ? true : false;
    const filteredprops = filteredRows.filter((x) =>
      selectedRow?.buildingId
        ? x.propertyMasterId === selectedRow.propertyMasterId &&
          x.buildingId === selectedRow?.buildingId
        : x.propertyMasterId === selectedRow.propertyMasterId,
    );
    const hasActive = filteredprops.some(
      (item) =>
        item.status === Statuses.NEW ||
        item.status === Statuses.SCHEDULED ||
        item.status === Statuses.INPROGRESS ||
        item.status === Statuses.SUBMITTEDFORAPPROVAL ||
        item.status === Statuses.REJECTED,
    );
    return isCompleted && !hasActive;
  };

  const handleDeleteinspection = async (inspectionMasterid) => {
    setButtonLoading(true);
    const payload = {
      inspectionIds: [inspectionMasterid],
      loggedInUserEmail: userObj?.userEmail,
    };
    // const params = new URLSearchParams();
    // payload.inspectionIds.forEach((id) => params.append("inspectionIds", id));
    // params.append("loggedInUserEmail", payload.loggedInUserEmail);

    // const queryString = params.toString();
    // console.log(queryString);
    // console.log(payload);
    try {
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION, JSON.stringify(payload));
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION + `?${query}`)
      const response = await http.delete(DELETE_PROPERTY_INSPECTION, {
        data: payload, // 👈 body goes in "data"
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Inspection has been deleted successfully.",
          });
        }, 1000);
        handleGetAllPropertyByClinetID(clientObj.clientId);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting inspection, please try again.",
          });
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setButtonLoading(false);
      setShowConfirmationPopup(false);
      setPropertyToDelete({});
    }
  };

  useEffect(() => {
    if (allPropertyList) {
      const tempfilteredRows = allPropertyList?.filter((row) => {
        const matchesSearch =
          !toolbar.searchText ||
          row.propertyName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspectionDate
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspectionDate
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          // row.inspectionMasterId == toolbar.searchText ||
          row.inspectionRefNumber
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.status?.toLowerCase().includes(toolbar.searchText.toLowerCase());

        const matchesPropertyName =
          toolbar.propertyName === "Property Name" ||
          row.propertyName.toLowerCase() === toolbar.propertyName.toLowerCase();

        const matchesInspector =
          toolbar.inspector === "Inspector" ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.inspector.toLowerCase());

        const matchesStatus =
          toolbar.status === "Status" ||
          (toolbar.status !== "Overdue" && row.status === toolbar.status) ||
          (toolbar.status === "Overdue" && row.isOverDue === true);

        const [start, end] = dateRange;
        let matchesDate = true; // Show all by default if no filter is set

        // 2. Only run logic if a Start Date is selected
        if (start) {
          // Check if the row has a valid Inspection Date (ignore N/A)
          if (row.inspectionDate && row.inspectionDate !== "N/A") {
            // Parse "DD/MM/YYYY" from row.inspectionDate
            const [d, m, y] = row.inspectionDate.split("/");

            // Create a comparable Date object (set time to midnight)
            // Note: Month is 0-indexed in JS Date (0 = Jan, 1 = Feb)
            const inspectionDate = new Date(y, m - 1, d);
            inspectionDate.setHours(0, 0, 0, 0);

            const startDate = new Date(start);
            startDate.setHours(0, 0, 0, 0);

            // 3. Define the Matching Logic
            if (!end) {
              // EXACT MATCH: If only one date is selected, show ONLY that date
              matchesDate = inspectionDate.getTime() === startDate.getTime();
            } else {
              // RANGE MATCH: If both dates are selected, show range
              const endDate = new Date(end);
              endDate.setHours(0, 0, 0, 0);
              matchesDate =
                inspectionDate >= startDate && inspectionDate <= endDate;
            }
          } else {
            // If filter is ON but row has "N/A", hide the row
            matchesDate = false;
          }
        }
        console.log("date", dateRange, start, end, matchesDate);

        return (
          matchesSearch &&
          matchesPropertyName &&
          matchesInspector &&
          matchesStatus &&
          matchesDate
        );
      });
      setFilteredRows(tempfilteredRows);
    } else {
      setFilteredRows(allPropertyList);
    }
  }, [allPropertyList, toolbar, dateRange]);
  // const stripTime = (date) => {
  //   const d = new Date(date);
  //   d.setHours(0, 0, 0, 0);
  //   return d;
  // };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDownloadClick = async (row) => {
    setLoadingRowId(row.id);

    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: row.propertyMasterId,
          inspectionReferenceNumber: row.inspectionRefNumber,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      setShowPdfModal(true);
      handleMenuClose();
    } catch (error) {
      // console.error("Download Failed", error);

      if (error?.status === 406) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Report not generated yet.",
        });
        handleMenuClose();
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Failed to download report.",
        });
      }
    } finally {
      setLoadingRowId(null);
    }
  };

  const handleExportActionItems = async (row) => {
    setExportLoadingRowId(row?.id);

    try {
      const payload = {
        clientId: clientObj?.clientId,
        propertyMasterId: null,
        searchText: row?.inspectionRefNumber || null,
        idSearch: null,
        priority: null,
        status: null,
        dueFrom: null,
        dueTo: null,
        pageNumber: 1,
        pageSize: 100,
      };

      const response = await http.post(DOWNLOAD_EXCEL_FILE, payload, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "ActionItems.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?([^;]+)/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/"/g, ""));
        }
      }
      const url = window.URL.createObjectURL(blob);
      if (
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome")
      ) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };

        reader.readAsDataURL(blob);
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ActionItems.xlsx");

        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: "Excel file downloaded successfully.",
      });
    } catch (err) {
      console.log(err);
      if (err?.status === 500) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "No action items found for the given criteria.",
        });
        handleMenuClose();
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Failed to download Excel file.",
        });
      }
    } finally {
      setExportLoadingRowId(null);
    }
  };

  const fetchDownloadExcel = async () => {
    //excel export
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("clientId", clientObj?.clientId);
      const queryString = params.toString();
      const response = await http.get(
        EXPORT_EXCEL_INSPECTIONS + `?${queryString}`,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "FDS_InspectionDetails.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?([^;]+)/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/"/g, ""));
        }
      }
      if (
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome")
      ) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };

        reader.readAsDataURL(blob);
      } else {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }

      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: "Excel file downloaded successfully.",
      });
    } catch (err) {
      console.error(err);
      const errmss =
        err?.response?.data?.message ??
        err?.message ??
        "Failed to download Excel file";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmss,
      });
    } finally {
      setLoading(false);
    }
  };

  const tableColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 120,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 120,
      flex: 0.4,
      // renderCell: (data) => {
      //   const isDisabled =
      //     data?.row?.status === Statuses.CANCELLED ? true : false;
      //   const isNew = data?.row?.status === Statuses.NEW || data?.row?.status === Statuses.SCHEDULED  ? true : false;
      //   const isCompleted = (data?.row?.status === Statuses.COMPLETED || data?.row?.status === Statuses.REJECTED) ? true : false;
      //   return (
      //     <Box >
      //       <img
      //         // disabled={isDisabled || isCompleted}
      //         tabIndex={0}
      //         alt="Edit Inspection"
      //         title="Edit Inspection"
      //         onClick={(isDisabled || isCompleted) ? () => {} : () => openEditScreen(data?.row?.inspectionMasterId)}
      //         src={(isDisabled || isCompleted) ? disabledEditIcon : activeEditIcon}
      //         style={(isDisabled || isCompleted) ? {cursor: 'inherit'} : {cursor: 'pointer'}}
      //       >
      //       </img>
      //       <img
      //         tabIndex={0}
      //         alt="Schedule Inspection"
      //         title="Schedule Inspection"
      //         onClick={(isDisabled || !isNew) ? () => {} : () => openScheduleScreen(data?.row?.inspectionMasterId)}
      //         src={(isDisabled || !isNew) ? disabledScheduleIcon : activeSchduleIcon}
      //         style={(isDisabled || !isNew) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

      //       >
      //       </img>
      //       {/* <img
      //         tabIndex={0}
      //         alt="Schedule Inspection"
      //         title="Schedule Inspection"
      //         onClick={(isDisabled || !isNew) ? () => {} : () => openScheduleInspectionRefNumberScreen(data?.row?.inspectionRefNumber)}
      //         src={(isDisabled || !isNew) ? disabledScheduleIcon : activeSchduleIcon}
      //         style={(isDisabled || !isNew) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

      //       /> */}
      //       <img
      //         disabled={isDisabled || isCompleted}
      //         tabIndex={0}
      //         title="Delete Inspection"
      //         alt="Delete Inspection"
      //         onClick={(isDisabled || isCompleted) ? () => {} : () => {
      //           setPropertyToDelete(data?.row);
      //           setShowConfirmationPopup(true);
      //         }}
      //         src={(isDisabled || isCompleted) ? disabledDeleteIcon : activeDeleteIcon}
      //         style={(isDisabled || isCompleted) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

      //       >
      //       </img>
      //          <img
      //         tabIndex={0}
      //         title="Booking History"
      //         alt="Booking History"
      //         onClick={() => openAuditScreen(data?.row?.inspectionRefNumber,data?.row?.propertyMasterId)}
      //         src={activeHistoryIcon}
      //         style={{cursor: 'pointer'}}
      //         >
      //       </img>
      //     </Box>
      //   );
      // },
      renderCell: (params) => (
        <>
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e, params.row)}
          >
            <MoreVertIcon />
          </IconButton>
          {params.row.isOverDue &&
            params.row.status !== Statuses.CANCELLED &&
            params.row.status !== Statuses.COMPLETED && (
              <i
                className="bi bi-info-circle"
                style={{
                  fontSize: "0.9rem",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
                title="This inspection is overdue."
              ></i>
            )}
        </>
      ),
      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Actions</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Click the three dots menu for each inspection to access edit/schedule/delete inspection, Booking History Download PDF and export Action Items for respective inspection."
          ></i>
        </span>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        return <StatusPill status={status} row={params.row} />;
      },
    },
    // {
    //   field: "isOverDue",
    //   headerName: "Overdue",
    //   width: 100,
    //   height: 50,
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: true,
    //   filterable: true,
    //   type: "string",
    //   minWidth: 100,
    //   flex: 1,
    //   renderCell: (params) => {
    //     const isOverDue = params.value;
    //     const status = params.row.status;

    //     if(isOverDue && (status !== Statuses.CANCELLED && status !== Statuses.COMPLETED)) return "Yes";
    //     return ""
    //   },
    // },
    {
      field: "date",
      width: 160,
      height: 50,
      headerName: "Approval Target Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      disableColumnMenu: true,
      type: "string",
      minWidth: 160,
      flex: 1.3,

      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Approval Target Date</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Expected date by which inspection should be approved."
          ></i>
        </span>
      ),
    },
    {
      field: "inspectionRefNumber",
      height: 50,
      width: 170,
      minWidth: 170,
      headerName: "Inspection Ref. No",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyName",
      height: 50,
      width: 200,
      minWidth: 200,
      headerName: "Site Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return (
          <span
            onClick={() => {
              if (!userObj?.isAdmin) return;

              const path = generatePath(
                "/client/:clientNameParam/viewSite/:propertyMasterId",
                {
                  clientNameParam,
                  propertyMasterId: data?.row?.propertyMasterId,
                },
              );
              navigate(path);
            }}
            style={{ cursor: "pointer" }}
          >
            {data?.row?.propertyName}
          </span>
        );
      },
    },
    {
      field: "buildingName",
      height: 50,
      width: 200,
      minWidth: 200,
      headerName: "Building Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
      renderCell: (data) => {
        return (
          <span
            onClick={() => {
              if (!userObj?.isAdmin) return;

              const path = generatePath(
                "/client/:clientNameParam/viewSite/:propertyMasterId",
                {
                  clientNameParam,
                  propertyMasterId: data?.row?.propertyMasterId,
                },
              );
              navigate(path);
            }}
            style={{ cursor: "pointer" }}
          >
            {data?.row?.buildingName}
          </span>
        );
      },
    },
    {
      field: "inspector",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Assigned Inspector(s)",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "inspectionDate",
      width: 150,
      height: 50,
      headerName: "Inspection Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "CreatedDate",
      width: 130,
      height: 50,
      headerName: "Created Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 130,
      flex: 1,
    },
  ];

  const sortedStatusOptions = allPropertyList
    ? Array.from(
        new Set([...allPropertyList.map((item) => item.status), "Overdue"]),
      ).sort((a, b) => a.localeCompare(b))
    : ["Overdue"];

  return (
    <>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        {/* Edit Inspection */}
        <MenuItem
          disabled={
            selectedRow?.status === Statuses.CANCELLED ||
            selectedRow?.status === Statuses.COMPLETED ||
            selectedRow?.status === Statuses.REJECTED ||
            selectedRow?.status === Statuses.SUBMITTEDFORAPPROVAL ||
            selectedRow?.status === Statuses.INPROGRESS
          }
          onClick={() => {
            if (
              selectedRow?.status !== Statuses.CANCELLED &&
              selectedRow?.status !== Statuses.COMPLETED &&
              selectedRow?.status !== Statuses.REJECTED &&
              selectedRow?.status !== Statuses.SUBMITTEDFORAPPROVAL &&
              selectedRow?.status !== Statuses.INPROGRESS
            ) {
              openEditScreen(selectedRow?.inspectionMasterId);
            }
            handleMenuClose();
          }}
        >
          <img
            src={
              selectedRow?.status === Statuses.CANCELLED ||
              selectedRow?.status === Statuses.COMPLETED ||
              selectedRow?.status === Statuses.REJECTED ||
              selectedRow?.status === Statuses.SUBMITTEDFORAPPROVAL ||
              selectedRow?.status === Statuses.INPROGRESS
                ? disabledEditIcon
                : activeEditIcon
            }
            width={18}
            style={{ marginRight: 8 }}
            alt="Edit Inspection"
          />
          Edit Inspection
        </MenuItem>

        {/* Schedule Inspection */}
        <MenuItem
          disabled={
            selectedRow?.status === Statuses.CANCELLED ||
            !(
              selectedRow?.status === Statuses.NEW ||
              selectedRow?.status === Statuses.SCHEDULED
            )
          }
          onClick={() => {
            if (
              selectedRow?.status !== Statuses.CANCELLED &&
              (selectedRow?.status === Statuses.NEW ||
                selectedRow?.status === Statuses.SCHEDULED)
            ) {
              openScheduleScreen(selectedRow?.inspectionMasterId);
            }
            handleMenuClose();
          }}
        >
          <img
            src={
              selectedRow?.status === Statuses.CANCELLED ||
              !(
                selectedRow?.status === Statuses.NEW ||
                selectedRow?.status === Statuses.SCHEDULED
              )
                ? disabledScheduleIcon
                : activeSchduleIcon
            }
            width={18}
            style={{ marginRight: 8 }}
            alt="Schedule Inspection"
          />
          Schedule Inspection
        </MenuItem>

        {/* Delete Inspection */}
        <MenuItem
          disabled={
            selectedRow?.status === Statuses.CANCELLED ||
            selectedRow?.status === Statuses.COMPLETED ||
            selectedRow?.status === Statuses.REJECTED ||
            selectedRow?.status === Statuses.SUBMITTEDFORAPPROVAL ||
            selectedRow?.status === Statuses.INPROGRESS
          }
          onClick={() => {
            if (
              selectedRow?.status !== Statuses.CANCELLED &&
              selectedRow?.status !== Statuses.COMPLETED &&
              selectedRow?.status !== Statuses.REJECTED &&
              selectedRow?.status !== Statuses.SUBMITTEDFORAPPROVAL &&
              selectedRow?.status !== Statuses.INPROGRESS
            ) {
              setPropertyToDelete(selectedRow);
              setShowConfirmationPopup(true);
            }
            handleMenuClose();
          }}
        >
          <img
            src={
              selectedRow?.status === Statuses.CANCELLED ||
              selectedRow?.status === Statuses.COMPLETED ||
              selectedRow?.status === Statuses.REJECTED ||
              selectedRow?.status === Statuses.SUBMITTEDFORAPPROVAL ||
              selectedRow?.status === Statuses.INPROGRESS
                ? disabledDeleteIcon
                : activeDeleteIcon
            }
            width={18}
            style={{ marginRight: 8 }}
            alt="Delete Inspection"
          />
          Delete Inspection
        </MenuItem>

        {/* duplicate Inspection */}

        {/* As of now Duplicate Inspection is comment */}

        {selectedRow?.status === Statuses.COMPLETED && (
          <MenuItem
            disabled={!checkAllowDuplicate(selectedRow)}
            onClick={() => {
              if (checkAllowDuplicate(selectedRow)) {
                openEditScreen(selectedRow?.inspectionMasterId);
              }
              handleMenuClose();
            }}
          >
            <img
              src={
                checkAllowDuplicate(selectedRow)
                  ? activeDuplicateIcon
                  : disabledDuplicateIcon
              }
              width={18}
              style={{ marginRight: 8 }}
              alt="Duplicate Inspection"
            />
            Duplicate Inspection
          </MenuItem>
        )}

        {/* Booking History */}
        <MenuItem
          onClick={() => {
            openAuditScreen(
              selectedRow?.inspectionRefNumber,
              selectedRow?.propertyMasterId,
            );
            handleMenuClose();
          }}
        >
          <img
            src={activeHistoryIcon}
            width={18}
            style={{ marginRight: 8 }}
            alt="Booking History"
          />
          Booking History
        </MenuItem>

        {/*Download PDF*/}
        <MenuItem
          disabled={
            selectedRow?.status === Statuses.INPROGRESS ||
            selectedRow?.status === Statuses.SCHEDULED ||
            selectedRow?.status === Statuses.NEW
          }
          onClick={() => {
            handleDownloadClick(selectedRow);
          }}
        >
          {loadingRowId === selectedRow?.id ? (
            <div
              className="loader"
              style={{ height: "18px", width: "18px", marginRight: "8px" }}
            ></div>
          ) : (
            <img
              src={activeDownloadIcon}
              width={18}
              style={{ marginRight: 8 }}
              alt="Download PDF"
            />
          )}
          Download PDF
        </MenuItem>

        {/*Export excel*/}
        <MenuItem
          disabled={
            selectedRow?.status === Statuses.INPROGRESS ||
            selectedRow?.status === Statuses.SCHEDULED ||
            selectedRow?.status === Statuses.NEW
          }
          onClick={() => {
            handleExportActionItems(selectedRow);
          }}
        >
          {exportLoadingRowId === selectedRow?.id ? (
            <div
              className="loader"
              style={{ height: "18px", width: "18px", marginRight: "8px" }}
            ></div>
          ) : (
            <img
              src={excelExportIcon}
              width={18}
              style={{ marginRight: 8 }}
              alt="Export Action Items"
            />
          )}
          Export Action Items
        </MenuItem>
      </Menu>
      <LoadingComponent loading={loading} />

      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Delete Inspection"
        infoText={`Please confirm if you want to delete inspection for Property: ${propertyToDelete.propertyName}`}
        cancelText="Cancel"
        submitText={buttonLoading ? "Deleting..." : "Delete"}
        onCancel={() => {
          closePopup();
        }}
        onSubmit={() =>
          handleDeleteinspection(propertyToDelete.inspectionMasterId)
        }
      />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="border-0 w-100">
              <div
                className="dashboard_header dashboard_header_inspection d-flex"
                style={{ textAlign: "justify" }} //marginTop: "37px" }}
              >
                <div>
                  <h2 className="mb-0">Inspections</h2>
                  <p className="header-description">
                    Manage and track all inspections
                  </p>
                </div>
                <div className="col-md-4 col-12 new-inspection-btn">
                  <button
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() =>
                      navigate(
                        generatePath("/client/:clientNameParam/inspection", {
                          clientNameParam,
                        }),
                      )
                    }
                  >
                    <i
                      className="fa fa-solid fa-plus"
                      style={{ paddingRight: "0.3rem" }}
                    ></i>
                    New Inspection
                  </button>
                </div>
              </div>

              <FilterSection
                setToolBar={setToolBar}
                toolbar={toolbar}
                dropdown1Value={toolbar.inspector}
                handleDropdown1Change={(e) =>
                  setToolBar({ ...toolbar, inspector: e.target.value })
                }
                dropdown1Options={inspectorOptions}
                dropdown1Text="Inspector"
                isdateRange={true}
                dateRange={dateRange}
                setDateRange={setDateRange}
                dropdown2Value={toolbar.status}
                handleDropdown2Change={(e) =>
                  setToolBar({ ...toolbar, status: e.target.value })
                }
                // dropdown2Options={allPropertyList?.map((user) => user.status)}
                dropdown2Options={sortedStatusOptions}
                dropdown2Text="Status"
                resetToolbar={() =>
                  setToolBar({
                    searchText: "",
                    propertyName: "Property Name",
                    inspector: "Inspector",
                    status: "Status",
                  })
                }
                isAnyFilterApplied={isAnyFilterApplied}
                button1Text="New Inspection"
                button1Path="/client/:clientNameParam/inspection"
                fetchDownloadExcel={fetchDownloadExcel}
              />
              <div className="inspection-table">
                <DynamicTable
                  tableData={filteredRows}
                  columnsValue={tableColumns}
                  pageSize={10}
                  rowHeight={45}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                  module="Inspections"
                />
              </div>
              <div className="inspection-tile">
                {filteredRows &&
                  filteredRows?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <InspectionTile
                        tableData={item}
                        openEditScreen={(itemid) => openEditScreen(itemid)}
                        openAuditScreen={(inspRef, propMaster) =>
                          openAuditScreen(inspRef, propMaster)
                        }
                        openScheduleScreen={(itemid) =>
                          openScheduleScreen(itemid)
                        }
                        setPropertyToDelete={setPropertyToDelete}
                        setShowConfirmationPopup={setShowConfirmationPopup}
                      />
                    );
                  })}
              </div>
            </div>
          </div>

          {showPdfModal && pdfUrl && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: "100vw",
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 1050,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  height: "90vh",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <button
                  className="btn-close"
                  onClick={() => {
                    setShowPdfModal(false);
                    setPdfUrl(null);
                  }}
                ></button>

                <Iframe
                  src={pdfUrl}
                  width="100%"
                  height="100%"
                  title="PDF Preview"
                />
              </div>
            </div>
          )}
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default Inspections;
